import { render } from "./DetailModal.vue?vue&type=template&id=24bdb16f&scoped=true"
import script from "./DetailModal.vue?vue&type=script&lang=js"
export * from "./DetailModal.vue?vue&type=script&lang=js"

import "./DetailModal.vue?vue&type=style&index=0&id=24bdb16f&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24bdb16f"]])

export default __exports__